<div *ngFor="let field of registrationFormFields" class="field-item">
    <label class="field-label bold">{{ field.name }}:</label> {{ field.value || 'N/A' }}
</div>
